<template>
  <div>
    <v-btn
      fab
      bottom
      right
      color="pink"
      dark
      fixed
      @click.stop="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" width="800px" persistent>
      <v-card>
        <v-card-title
          class="grey lighten-4 py-4 title"
        >
          Add Plan
        </v-card-title>
        <v-container grid-list-sm class="pa-4">
          <v-layout align-center raw wrap>
            <v-flex xs12 align-center justify-space-between>
              <v-text-field
                placeholder="Plan name"
                v-model="modelName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 align-center justify-space-between>
              <v-text-field
                placeholder="Plan price"
                type="number"
                prefix="$"
                persistent-hint
                v-model="planPrice"
                :suffix="selectedCasket ? '+ casket price $ ' + casketById(selectedCasket).price : ''"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 align-center justify-space-between>
              <v-select
                :items="allCaskets"
                v-model="selectedCasket"
                label="Select Casket Model"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs12 align-center justify-space-between>
              <v-combobox
                :items="products"
                v-model="selectedProducts"
                hide-selected
                multiple
                persistent-hint
                small-chips
                label="Select Products"
              >
              </v-combobox>
            </v-flex>

            <v-flex xs12 align-center justify-space-between>
            <v-data-table
              v-if="selectedProducts && selectedProducts.length"
              :items="selectedProducts"
              :headers="productsTableHeaders"
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.name }}</td>
                <td class="quantity_bgcolor">
                  <v-edit-dialog
                    :return-value.sync="props.item.amount"
                    lazy
                  >
                    {{ props.item.amount }}
                    <v-text-field
                      slot="input"
                      v-model="props.item.amount"
                      label="Quantity"
                    >
                    </v-text-field>
                  </v-edit-dialog>
                </td>
                <td>${{ props.item.price }}</td>
                <td>${{ props.item.amount * props.item.price }}</td>
              </template>
            </v-data-table>
            </v-flex>

            <span v-if="totalPrice > 0"><b>Total price: ${{ totalPrice || 0 }}</b></span>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn color="primary" @click="saveNew">Save</v-btn>
          <v-btn flat @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AppMainDialog :open="dialogOpen" :message="dialogMessage" @closedialog="dialogOpen = false"></AppMainDialog>
  </div>
</template>

<script>
  import CrudAPI from '@/api/resources/crud'
  import AppMainDialog from '@/components/AppMainDialog'
  import AddButtonMixins from '@/mixins/AddButton'
  import { mapGetters } from 'vuex'
  import _ from 'lodash'

  export default {
    components: { AppMainDialog },
    mixins: [ AddButtonMixins ],
    computed: {
      ...mapGetters({
        products: 'allProducts',
        serviceById: 'getProductById',
        plans: 'allPlans',
        allCaskets: 'allCaskets',
        casketById: 'getCasketById',
        filterFromLinkedServices: 'filterFromLinkedServices',
        filterCasketFromLinkedProducts: 'filterCasketFromLinkedProducts',
        removeCasketsFromServices: 'removeCasketsFromServices'
      }),
      totalPrice () {
        if (!this.planPrice && !this.selectedCasket && !this.selectedProducts) return false
        return parseFloat(this.planPrice) +
          (this.casketById(this.selectedCasket) ? parseFloat(this.casketById(this.selectedCasket).price) : 0) +
          (this.selectedProducts ? _.reduce(this.selectedProducts, (sum, p) => {
            return sum + parseFloat(p.price) * p.amount
          }, 0) : 0)
      }
    },
    data () {
      return {
        resources: 'plans',
        dialog: false,
        modelName: '',
        planPrice: 0,
        selectedProducts: [],
        productsTableHeaders: [
          { text: 'Name', value: 'name' },
          { text: 'Qty', value: 'amount', width: '5px' },
          { text: 'Unit', value: 'price' },
          { text: 'Subtotal', value: 'price' }
        ],
        selectedCasket: null,
        dialogMessage: '',
        dialogOpen: false
      }
    },
    methods: {
      saveNew () {
        this.selectedCasket ? this.selectedProducts.push(this.casketById(this.selectedCasket)) : null
        let payload = {
          name: this.modelName,
          price: this.planPrice,
          services: this.selectedProducts
        }

        let result = CrudAPI.dfsResourceStore(this.resources, payload)

        this.selectedProducts = this.removeCasketsFromServices(this.selectedProducts)

        result.then(this.saveNewSuccess, this.saveNewError)
        this.$store.dispatch('getAllPlans')
      }
    },
    beforeCreate () {
      this.$store.dispatch('getAllPlans')
      this.$store.dispatch('getAllProducts')
    },
    created () {}
  }
</script>



// WEBPACK FOOTER //
// AddPlanButton.vue?4f519f92